export default "__VITE_ASSET__lz34RNa$__"